import _defineProperty from "@babel/runtime/helpers/defineProperty";
const MAX_CONTEXTS = 6;
class Counter {
  constructor() {
    _defineProperty(this, "set", new Set());
    this.set = new Set();
  }
  add(key) {
    if (this.set.has(key)) {
      return true;
    }
    if (this.count < MAX_CONTEXTS) {
      this.set.add(key);
      return true;
    }
    return false;
  }
  remove(key) {
    this.set.delete(key);
  }
  get count() {
    return this.set.size;
  }
}
export default new Counter();
//# sourceMappingURL=contextManager.js.map